import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    TgButtons2Module,
    TgGridModule,
    TgInputGroupModule,
    TgInputModule,
    TgLoadingModule
} from '@trademe/tangram';
import { Property3DTourSectionComponent } from './property-3d-tour-section.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgGridModule,
        TgInputModule,
        TgInputGroupModule,
        TgButtons2Module,
        TgLoadingModule
    ],
    declarations: [Property3DTourSectionComponent],
    exports: [Property3DTourSectionComponent]
})
export class Property3DTourSectionModule {}
